import React from 'react';
import { Box, Typography } from '@mui/material';

const Settings: React.FC = () => (
  <Box sx={{ color: '#fff', p: 4 }}>
    <Typography variant="h4">Settings</Typography>
    <Typography sx={{ mt: 2 }}>Settings page (stub)</Typography>
  </Box>
);

export default Settings;
